import SignatureCanvas from "react-signature-canvas";

import { Button, Modal, message } from "antd";
import { useRef } from "react";

import styles from "@/components/SignaturePad/SignaturePad.module.css";
import { fileUpload } from "@/services/Auth/AuthApi";

interface SignaturePadProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (url: string) => void;
}

const SignaturePad: React.FC<SignaturePadProps> = ({ open, onClose, onSubmit }) => {
  const sigRef = useRef<SignatureCanvas>(null);

  const clear = (): void => {
    sigRef.current?.clear();
  };

  const onSave = (): void => {
    if (!sigRef.current || sigRef.current.isEmpty()) {
      message.warning("Please provide a signature");
      return;
    }

    sigRef.current.getCanvas().toBlob(async (blob) => {
      if (!blob) return;

      const file = new File([blob], "signature.png", {
        type: "image/png",
        lastModified: Date.now(),
      });

      try {
        const response = await fileUpload({
          file,
          type: "pledge",
        });

        message.success("Signature uploaded successfully");
        onSubmit(response?.url);
      } catch (error) {
        console.error(error);
        message.error("Failed to upload signature");
      }
    }, "image/png");
  };

  return (
    <Modal
      title="Sign with e-signature"
      open={open}
      onCancel={onClose}
      footer={null}
      width={700}
      centered
    >
      <div data-dd-privacy="mask">
        <SignatureCanvas
          ref={sigRef}
          penColor="black"
          canvasProps={{
            width: 650,
            height: 400,
            style: {
              border: "1px solid #ccc",
              background: "#fff",
              marginTop: 12,
            },
          }}
        />
      </div>

      <div className={styles.buttonWrapper}>
        <Button onClick={clear} className={styles.clearButton}>
          Clear
        </Button>
        <Button onClick={onSave} className={styles.applyButton}>
          Save
        </Button>
      </div>
    </Modal>
  );
};

export default SignaturePad;
